import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"

export const useProduct = (slug) => {
    return useQuery({
        queryKey: ['product'],
        queryFn: async () => {
            const res = await Axios.get(`/product/get/${slug}`)
            return res?.data
        }
    })
}       